export default __webpack_public_path__ + "static/media/step_1.b2995152.jpeg";